import auth from "../../auth/service.jsx";
import { CitizenProfile } from "../../user/models";

class Request {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};

		this.id = jsonData.id;
		this.creationTime = jsonData.creationTime;
		this.userId = jsonData.userId;
		this.serviceId = jsonData.serviceId;
		this.lastUpdate = jsonData.lastUpdate;
		this.state = jsonData.state;

		if (jsonData.userProfile) {
			this.userProfile = new CitizenProfile(jsonData.userProfile);
		}

	}	

	creation() {
		let now = new Date().getTime();
		this.id = 0;
		this.creationTime = now;
		this.lastUpdate = now;
		this.state = 0;
		this.userProfile = null;
		this.userId = auth.getUser().id;
	}

}

class Reply {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};

		this.id = jsonData.id;
		this.requestId = jsonData.requestId;
		this.creationTime = jsonData.creationTime;
		this.userId = jsonData.userId;
		this.serviceId = jsonData.serviceId;
		this.lastUpdate = jsonData.lastUpdate;
		this.code = jsonData.code;

	}	

	creation() {
		let now = new Date().getTime();
		this.id = 0;
		this.creationTime = now;
		this.lastUpdate = now;
		this.code = 0;
		this.userId = auth.getUser().id;
	}
}

export { Request, Reply };
